var styles = {"container":"Otp-module_container__cBLbY","notification":"Otp-module_notification__Kyt95","field":"Otp-module_field__VcZMw","otpInput--error":"Otp-module_otpInput--error__9gtc6","otpInput":"Otp-module_otpInput__pWwDm","otpButton":"Otp-module_otpButton__50-37","info":"Otp-module_info__IM7Vh","resendCode":"Otp-module_resendCode__-gxfQ","backLink":"Otp-module_backLink__WepbJ"};

export { styles as default };
//# sourceMappingURL=Otp.module.scss.js.map
